export default __webpack_public_path__ + "static/media/ups-logo.bff25faf.svg";